export default __webpack_public_path__ + "static/media/category-cloud.png";